import { useQuery } from '@apollo/client';
import { notEmpty } from '@crehana/utils';

import GET_SKILL_XP_TAGS_BY_TRACK from '../graphql/GetSkillXPTagsByTrack.graphql';
import type {
  GetSkillXPTagsByTrack,
  GetSkillXPTagsByTrackVariables,
} from '../graphql/types/GetSkillXPTagsByTrack';

const useSkillXPTagsByTrack = (trackId: number) => {
  const { data, error, loading } = useQuery<
    GetSkillXPTagsByTrack,
    GetSkillXPTagsByTrackVariables
  >(GET_SKILL_XP_TAGS_BY_TRACK, {
    variables: { trackId },
  });

  const tags =
    data?.skillB2BTagsByTrack?.tags?.map(el => el).filter(notEmpty) || [];

  const status = data && data.skillB2BTagsByTrack?.skillB2BUser?.status;
  const skillB2BUserId =
    data && data.skillB2BTagsByTrack?.skillB2BUser?.originalId;
  const skillB2bTrackName =
    data && data.skillB2BTagsByTrack?.skillB2BUser?.skillB2B.track?.name;

  return {
    tags,
    skillB2BUserId,
    skillB2bTrackName,
    status,
    loading,
    error,
  };
};

export default useSkillXPTagsByTrack;
